import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/cb57efd0-2bdc-4109-9706-5ee332c3bb0a/images/cd582a59b1cfc3728cb48e6f787fe6830bba8a8dd2587c87f5b872f3bcb2979a.png";
const BG_URL = "https://static.prod-images.emergentagent.com/jobs/cb57efd0-2bdc-4109-9706-5ee332c3bb0a/images/04ba5026376b5b65246965f6051098714a06f029eff03ce107a2431a0bbeb656.png";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("info@omnilinksolutions.net");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid="login-page">
      {/* Left: form */}
      <div className="flex items-center justify-center p-8 md:p-16">
        <div className="w-full max-w-md fade-up">
          <div className="flex items-center gap-3 mb-12">
            <img src={LOGO_URL} alt="Omnilink" className="h-10 w-10" />
            <div>
              <div className="font-display font-bold text-lg leading-tight text-gray-950">Omnilink Solutions</div>
              <div className="text-[11px] tracking-[0.22em] uppercase text-gray-500">Lead Management</div>
            </div>
          </div>

          <div className="mb-8">
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-gray-500 mb-3">Sign In</div>
            <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-gray-950 leading-[1.05]">
              Welcome back.
            </h1>
            <p className="text-gray-600 mt-3 text-base">
              Sign in to manage your leads, dedupe and download.
            </p>
          </div>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-xs font-semibold tracking-[0.18em] uppercase text-gray-700">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 rounded-sm h-11 focus-visible:ring-[#002FA7] focus-visible:ring-2"
                data-testid="login-email-input"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-semibold tracking-[0.18em] uppercase text-gray-700">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 rounded-sm h-11 focus-visible:ring-[#002FA7] focus-visible:ring-2"
                data-testid="login-password-input"
                required
              />
            </div>
            {error && (
              <div className="text-sm text-[#FF3B30] border-l-2 border-[#FF3B30] pl-3" data-testid="login-error">
                {error}
              </div>
            )}
            <Button
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-sm bg-[#002FA7] hover:bg-[#002480] text-white font-medium tracking-wide"
              data-testid="login-submit-button"
            >
              {loading ? "Signing in…" : "Sign In →"}
            </Button>
          </form>

          <div className="mt-12 text-xs text-gray-500">
            © {new Date().getFullYear()} Omnilink Solutions. Internal portal.
          </div>
        </div>
      </div>

      {/* Right: visual */}
      <div
        className="hidden lg:block relative bg-gray-100"
        style={{ backgroundImage: `url(${BG_URL})`, backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/10 via-transparent to-black/20" />
        <div className="absolute bottom-10 left-10 right-10 text-white drop-shadow">
          <div className="font-mono text-xs tracking-[0.3em] uppercase opacity-80">Omnilink / Operations</div>
          <div className="font-display text-3xl font-semibold mt-2 max-w-md">Precision lead ingestion, dedupe, and reporting — all in one place.</div>
        </div>
      </div>
    </div>
  );
}
